// eslint-disable-next-line import/no-anonymous-default-export
export default {
  items: {
    byMenuId: {},
  },
  menus: {
    byId: {},
  },
  cart: {
    lineItems: [],
    userNotes: null,
    orderNotes: null,
    taxExemptData: {
      reason: '',
      taxExempt: false,
      taxExemptApproverUuid: '',
    },
  },
  config: {
    hasConfig: false,
    shouldRefreshConfig: true,
    networkAvailable: true,
    backbarMode: false,
    kioskBarcodeScanningEnabled: false,
  },
  order: {
    byId: {},
    offlineCardIds: [],
    failureRemoteIds: [],
    offlineLocalIds: [],
    successRemoteIds: [],
    purgedAt: undefined,
    syncMultiplicandInMinutes: 4,
    orderInProgress: {},
    ordersFilter: {
      state: 'tabbed',
      showOrders: 'all orders',
    },
  },
  peripheral: {
    peripheralConnected: true,
  },
  refund: {
    byId: {},
    failureRemoteIds: [],
    successRemoteIds: [],
  },
  revenueCenter: {
    byId: {
      unassigned: {
        uuid: 'unassigned',
        name: 'Unassigned Orders',
      },
    },
    allIds: ['unassigned'],
    activeRevenueCenter: undefined,
  },
  categories: {
    byMenuId: {},
  },
}
